export type BookingStage = "new" | "quoted" | "confirmed" | "scheduled";

export type Booking = {
  id: string;
  customer: string;
  initials: string;
  color: string;
  email: string;
  phone: string;
  moveType: string;
  preferredDate: string;
  preferredTime: string;
  fromCity: string;
  toCity: string;
  rooms: string;
  estimatedQuote: number | null;
  depositRequired: number | null;
  depositPaid: boolean;
  stage: BookingStage;
  source: string;
  submittedAt: string;
  notes: string;
};

export const bookings: Booking[] = [
  {
    id: "BK-7821",
    customer: "Hannah Wallace",
    initials: "HW",
    color: "bg-brand-500",
    email: "hannah.wallace@gmail.com",
    phone: "(512) 555-0411",
    moveType: "Residential — 4 BR House",
    preferredDate: "Sat, Jun 14",
    preferredTime: "08:00 AM",
    fromCity: "Austin, TX",
    toCity: "Dripping Springs, TX",
    rooms: "4 BR / 3 BA",
    estimatedQuote: 2840,
    depositRequired: 568,
    depositPaid: true,
    stage: "confirmed",
    source: "Google Search",
    submittedAt: "12 min ago",
    notes: "Has a baby grand piano and 2 dogs. Long driveway, no elevator.",
  },
  {
    id: "BK-7822",
    customer: "Marcus Tribble",
    initials: "MT",
    color: "bg-emerald-500",
    email: "m.tribble@protonmail.com",
    phone: "(512) 555-0428",
    moveType: "Apartment — Studio",
    preferredDate: "Sun, Jun 15",
    preferredTime: "10:00 AM",
    fromCity: "Austin, TX",
    toCity: "Buda, TX",
    rooms: "Studio",
    estimatedQuote: 640,
    depositRequired: 128,
    depositPaid: false,
    stage: "quoted",
    source: "Referral",
    submittedAt: "38 min ago",
    notes: "Customer wants packing service add-on.",
  },
  {
    id: "BK-7823",
    customer: "The Okonkwo Family",
    initials: "TO",
    color: "bg-indigo-500",
    email: "j.okonkwo@gmail.com",
    phone: "(512) 555-0436",
    moveType: "Residential — 3 BR + Storage",
    preferredDate: "Mon, Jun 16",
    preferredTime: "07:00 AM",
    fromCity: "Round Rock, TX",
    toCity: "San Antonio, TX",
    rooms: "3 BR / 2 BA",
    estimatedQuote: 3420,
    depositRequired: 684,
    depositPaid: true,
    stage: "scheduled",
    source: "Yelp",
    submittedAt: "1 hr ago",
    notes: "Long distance, needs storage drop-off for 2 weeks.",
  },
  {
    id: "BK-7824",
    customer: "Lila Bergstrom",
    initials: "LB",
    color: "bg-rose-500",
    email: "lila.b@outlook.com",
    phone: "(512) 555-0442",
    moveType: "Apartment — 2 BR",
    preferredDate: "Tue, Jun 17",
    preferredTime: "01:00 PM",
    fromCity: "Austin, TX",
    toCity: "Austin, TX",
    rooms: "2 BR / 2 BA",
    estimatedQuote: 1180,
    depositRequired: 236,
    depositPaid: true,
    stage: "scheduled",
    source: "Instagram Ad",
    submittedAt: "2 hr ago",
    notes: "3rd floor walk-up at origin. Has gym equipment.",
  },
  {
    id: "BK-7825",
    customer: "Chen & Wei Family",
    initials: "CW",
    color: "bg-teal-500",
    email: "chen.wei.family@gmail.com",
    phone: "(512) 555-0451",
    moveType: "Residential — 5 BR House",
    preferredDate: "Sat, Jun 21",
    preferredTime: "07:30 AM",
    fromCity: "Cedar Park, TX",
    toCity: "Westlake, TX",
    rooms: "5 BR / 4 BA",
    estimatedQuote: null,
    depositRequired: null,
    depositPaid: false,
    stage: "new",
    source: "Website Form",
    submittedAt: "Just now",
    notes: "Custom request — needs in-home estimate. Big inventory.",
  },
  {
    id: "BK-7826",
    customer: "Devontae Banks",
    initials: "DB",
    color: "bg-amber-500",
    email: "dev.banks@gmail.com",
    phone: "(512) 555-0463",
    moveType: "Apartment — 1 BR",
    preferredDate: "Sat, Jun 21",
    preferredTime: "11:00 AM",
    fromCity: "Austin, TX",
    toCity: "Austin, TX",
    rooms: "1 BR / 1 BA",
    estimatedQuote: 720,
    depositRequired: 144,
    depositPaid: false,
    stage: "quoted",
    source: "Google Search",
    submittedAt: "3 hr ago",
    notes: "Has a 75\" TV and gaming setup.",
  },
  {
    id: "BK-7827",
    customer: "Penelope Hart",
    initials: "PH",
    color: "bg-fuchsia-500",
    email: "p.hart@gmail.com",
    phone: "(512) 555-0478",
    moveType: "Senior Move — 2 BR Condo",
    preferredDate: "Sun, Jun 22",
    preferredTime: "09:00 AM",
    fromCity: "Austin, TX",
    toCity: "Georgetown, TX",
    rooms: "2 BR / 2 BA",
    estimatedQuote: 1480,
    depositRequired: 296,
    depositPaid: false,
    stage: "new",
    source: "Phone Call",
    submittedAt: "5 hr ago",
    notes: "Daughter is handling logistics. Lots of antiques and china.",
  },
  {
    id: "BK-7828",
    customer: "TerraTech Studios LLC",
    initials: "TS",
    color: "bg-orange-600",
    email: "ops@terratechstudios.com",
    phone: "(512) 555-0489",
    moveType: "Office Relocation",
    preferredDate: "Sat, Jun 28",
    preferredTime: "06:00 AM",
    fromCity: "Austin, TX",
    toCity: "Round Rock, TX",
    rooms: "12 desks · server room",
    estimatedQuote: 5240,
    depositRequired: 1048,
    depositPaid: true,
    stage: "confirmed",
    source: "Referral",
    submittedAt: "Yesterday",
    notes: "Weekend move required. Server racks need extra care.",
  },
  {
    id: "BK-7829",
    customer: "Aimee Whitaker",
    initials: "AW",
    color: "bg-cyan-600",
    email: "aimee.w@yahoo.com",
    phone: "(512) 555-0496",
    moveType: "Apartment — 2 BR",
    preferredDate: "Wed, Jun 18",
    preferredTime: "10:00 AM",
    fromCity: "Austin, TX",
    toCity: "Pflugerville, TX",
    rooms: "2 BR / 2 BA",
    estimatedQuote: null,
    depositRequired: null,
    depositPaid: false,
    stage: "new",
    source: "Website Form",
    submittedAt: "Yesterday",
    notes: "Asked if Haulmark offers eco-friendly packing materials.",
  },
];

export const bookingStages = [
  {
    key: "new",
    label: "New Requests",
    description: "Awaiting first response",
    color: "bg-amber-500",
    accent: "border-amber-500",
  },
  {
    key: "quoted",
    label: "Quoted",
    description: "Estimate sent",
    color: "bg-indigo-500",
    accent: "border-indigo-500",
  },
  {
    key: "confirmed",
    label: "Confirmed",
    description: "Deposit received",
    color: "bg-brand-500",
    accent: "border-brand-500",
  },
  {
    key: "scheduled",
    label: "Scheduled",
    description: "Crew assigned",
    color: "bg-emerald-500",
    accent: "border-emerald-500",
  },
] as const;

export const bookingStats = [
  {
    label: "New This Week",
    value: "27",
    sub: "+18% vs last week",
    icon: "ri-calendar-event-line",
    color: "text-amber-600 bg-amber-50",
  },
  {
    label: "Conversion Rate",
    value: "68%",
    sub: "quote → confirmed",
    icon: "ri-filter-3-line",
    color: "text-indigo-600 bg-indigo-50",
  },
  {
    label: "Avg Quote Value",
    value: "$1,840",
    sub: "this month",
    icon: "ri-price-tag-3-line",
    color: "text-brand-600 bg-brand-50",
  },
  {
    label: "Avg Response Time",
    value: "12m",
    sub: "first reply",
    icon: "ri-time-line",
    color: "text-emerald-600 bg-emerald-50",
  },
];